import React, { ReactNode } from 'react'
import styled from 'styled-components'

interface ButtonProps {
  children: ReactNode
  onClick?: any
  className?: any
  disabled?: any
  loading?: boolean
  color?: string
  // blur?: boolean
}

const Wrapper = styled.div`
  /* width:70%; */
`
const BaseButton = styled.button`
  border: 0;
  background-color: ${({ theme }) => theme.colors.primary};
  border-radius: 10px;
  /* padding: 18px 152px; */
  color: ${({ theme }) => theme.colors.white};
  cursor: pointer;
  font-family: ${({ theme }) => theme.fontFamily.inter};
  font-style: normal;
  font-weight: 400;
  font-size: ${({ theme }) => theme.fontSize.x5};
  line-height: 22px;
  height: 60px;
  width: 90%;
  letter-spacing: 0.75px;
  transition: background 250ms ease-in;
  overflow: hidden;
  /* &:hover {
    background: ${({ theme }) => theme.colors.successGreen};
    color: ${({ theme }) => theme.colors.white};
  }
  &:focus {
    background-color: ${({ theme }) => theme.colors.successGreen};
    color: ${({ theme }) => theme.colors.white};
  } */
`
const CustomButton = ({
  onClick,
  children,
  disabled,
  loading = false,
  ...rest
}: ButtonProps) => {
  return (
    <Wrapper>
      <BaseButton onClick={onClick} disabled={disabled || loading} {...rest}>
        {children}
      </BaseButton>
    </Wrapper>
  )
}

const QuickSaveButton = styled(CustomButton)`
  background-color: ${({ theme }) => theme.colors.Btnprimary};
  padding: 20px;
  width: 220px;
  font-size: ${({ theme }) => theme.fontSize.x1};
  color: ${({ theme }) => theme.colors.BtnWhite};
  height: 62px;
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 107px;
    font-size: ${({ theme }) => theme.fontSize.x4};
    height: 33px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8.8px;
  }
`

const HomeQuickSaveBtn = styled(CustomButton)`
  width: 150px;
  height: 50px;
  background: ${({ theme }) => theme.colors.homeQuickSaveBg};
  border-radius: 10px;
  font-size: ${({ theme }) => theme.fontSize.x5};
  font-weight: 400;
  line-height: 22px;
  font-family: ${({ theme }) => theme.fontFamily.inter};
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 100px;
    height: 30px;
    font-size: ${({ theme }) => theme.fontSize.x4};
    border-radius: 5px;
  }
`

const EmergencyBtn = styled(HomeQuickSaveBtn)`
  background: ${({ theme }) => theme.colors.emergencyColor};
`

const EmergencyWithdrawBtn = styled(EmergencyBtn)`
  background: transparent;
  color: ${({ theme }) => theme.colors.emergencyColor};
  border: 1px solid ${({ theme }) => theme.colors.emergencyColor};
`

const ResetButton = styled(CustomButton)`
  background-color: ${({ theme }) => theme.colors.resetColor};
`
const TargetButton = styled(CustomButton)`
  background-color: ${({ theme }) => theme.colors.successGreen};
  padding: 19px 34px;
`

const InvestModalButton = styled(CustomButton)`
  background-color: ${({ theme }) => theme.colors.investColor};
  width: 100%;
  height: 60px;
  font-size: ${({ theme }) => theme.fontSize.x1};
  padding: 20px;
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 100%;
  }
`
const InvestButton = styled(CustomButton)`
  background-color: ${({ theme }) => theme.colors.investColor};
  padding: 8px 57px;
`
const DownloadButton = styled(CustomButton)`
  background-color: ${({ theme }) => theme.colors.secondPrimary};
  padding: 8px 12px;
  width: 192px;
  font-size: ${({ theme }) => theme.fontSize.x3};
  height: 40px;
  color: ${({ theme }) => theme.colors.BtnWhite};
`

const RegisterBtn = styled(CustomButton)`
  background-color: ${({ theme }) => theme.colors.primary};
  /* margin: 0 auto; */
  height: 50px;
  /* margin-left: 2rem; */
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  color: ${({ theme }) => theme.colors.white};
  opacity: 0.8;
  width: 100%;

  @media (max-width: ${({ theme }) => theme.responsive.laptop}) {
    width: 100%;
  }
  @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
    width: 100%;
  }
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 100%;
  }
`
const ModalButton = styled(CustomButton)`
  overflow: hidden;
  background: #6979f8;
  border-radius: 5px;
  width: 100%;
  height: 50px;
  font-size: ${({ theme }) => theme.fontSize.x5};
  padding: 20px;
  line-height: 22px;
  font-style: normal;
  font-weight: 300;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 100%;
  }
`

const VerificationButton = styled(CustomButton)`
  background: #6979f8;
  border-radius: 5px;
  width: 100%;
  height: 50px;
  font-size: ${({ theme }) => theme.fontSize.x5};
  padding: 20px;
  line-height: 22px;
  font-style: normal;
  font-weight: 300;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 100%;
  }
`

const InvestSuccessBtn = styled(ModalButton)`
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.homeQuickSaveBg};
  width: 100%;
`

// const CreateButton = styled(CustomButton)`
//   background: ${({ theme }) => theme.colors.homeQuickSaveBg};
//   width: 130px;
//   height: 30px;
//   font-size: ${({ theme }) => theme.fontSize.x5};
//   overflow: hidden;
//   line-height: 22px;
//   display: flex;
//   align-items: center;
//   justify-content: center;

//   @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
//     width: 70px;
//     font-size: ${({ theme }) => theme.fontSize.x4};
//   }
// `
const CreateButton = styled(CustomButton)`
  width: 150px;
  height: 50px;
  background: ${({ theme }) => theme.colors.homeQuickSaveBg};
  border-radius: 10px;
  font-size: ${({ theme }) => theme.fontSize.x5};
  font-weight: 400;
  line-height: 22px;
  font-family: ${({ theme }) => theme.fontFamily.inter};
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 100px;
    height: 30px;
    font-size: ${({ theme }) => theme.fontSize.x4};
    border-radius: 5px;
  }
`

const DeleteContestBtn = styled(CreateButton)`
  background: ${({ theme }) => theme.colors.red};
`

const SavingsBtn = styled(CustomButton)`
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 107px;
    font-size: ${({ theme }) => theme.fontSize.x4};
    height: 33px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8.8px;
  }
`

const GeneralSave = styled(CustomButton)`
  width: 230px;
  height: 52px;
  border-radius: 10px;
  background-color: ${({ theme }) => theme.colors.Btnprimary};
  color: ${({ theme }) => theme.colors.white};
  margin: 0 20px;
  font-size: ${({ theme }) => theme.fontSize.xl};
  line-height: 24px;
  font-weight: 200;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 150px;
    font-size: ${({ theme }) => theme.fontSize.x2};
    margin: 2rem 10px;
  }
`
const CollaboAcceptButton = styled(CustomButton)`
  background-color: ${({ theme }) => theme.colors.CollaboBlue};
  padding: 0px 12px;
  width: 192px;
  cursor: pointer;
  font-size: ${({ theme }) => theme.fontSize.s};
  height: 40px;
  font-style: normal;
  font-weight: bold;
  border-radius: 10px;
  color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.CollaboBlue};
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 125px;
    font-size: 9px;
    height: 26px;
    padding: 0px 8px;
    border-radius: 6px;
  }
  @media (max-width: 350px) {
    width: 95px;
  }
`
const CollaboDeclineButton = styled(CustomButton)`
  background-color: transparent;
  padding: 0px 12px;
  width: 192px;
  cursor: pointer;
  font-size: ${({ theme }) => theme.fontSize.s};
  height: 40px;
  font-style: normal;
  font-weight: bold;
  border-radius: 10px;
  color: ${({ theme }) => theme.colors.dark};
  border: 1px solid ${({ theme }) => theme.colors.CollaboBlue};
  margin-left: 30px;
  @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
    width: 125px;
    font-size: 9px;
    height: 26px;
    padding: 0px 8px;
    border-radius: 6px;
  }
  @media (max-width: 350px) {
    width: 95px;
  }
`

const InvestmentInvestButton = styled(CustomButton)`
  background: ${({ theme }) => theme.colors.investColor};
  padding: 0px 12px;
  width: 192px;
  font-size: ${({ theme }) => theme.fontSize.s};
  height: 40px;
  font-style: normal;
  font-weight: bold;
  border-radius: 10px;
  color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.investColor};
  @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
    width: 125px;
    font-size: 9px;
    height: 26px;
    padding: 0px 8px;
    border-radius: 6px;
  }
  @media (min-width: 1100px) and (max-width: ${({ theme }) =>
      theme.responsive.laptop}) {
    width: 149px;
  }
`
const InvestmentLearnButton = styled(CustomButton)`
  background: transparent;
  padding: 0px 12px;
  width: 192px;
  font-size: ${({ theme }) => theme.fontSize.s};
  height: 40px;
  font-style: normal;
  font-weight: bold;
  border-radius: 10px;
  color: ${({ theme }) => theme.colors.dark};
  border: 1px solid ${({ theme }) => theme.colors.investColor};
  margin-left: 30px;
  @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
    width: 125px;
    font-size: 9px;
    height: 26px;
    padding: 0px 8px;
    border-radius: 6px;
  }
  @media (min-width: 1100px) and (max-width: ${({ theme }) =>
      theme.responsive.laptop}) {
    width: 149px;
  }
`

const GeneralWithdraw = styled(HomeQuickSaveBtn)`
  background: transparent;
  border: 1px solid ${({ theme }) => theme.colors.homeQuickSaveBg};
  color: ${({ theme }) => theme.colors.homeQuickSaveBg};
`

// Target btn

const CreateTarget = styled(HomeQuickSaveBtn)`
  background-color: ${({ theme }) => theme.colors.successGreen};
`

const TargetMore = styled(CreateTarget)`
  background-color: transparent;
  border: 1px solid ${({ theme }) => theme.colors.successGreen};
  color: ${({ theme }) => theme.colors.successGreen};
`

const CreateEmergency = styled(CustomButton)`
  width: 230px;
  height: 52px;
  border-radius: 10px;
  color: ${({ theme }) => theme.colors.white};
  margin: 0 20px;
  font-size: ${({ theme }) => theme.fontSize.xl};
  line-height: 24px;
  font-weight: 200;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 97px;
    height: 30px;
    font-size: ${({ theme }) => theme.fontSize.x4};
    margin: 1rem 10px;
    border-radius: 5px;
  }
`

const TargetFilterBtn = styled(CustomButton)`
  width: auto;
  padding: 5px 10px;
  height: 32px;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.successGreen};
  border: 1px solid ${({ theme }) => theme.colors.successGreen};
  font-size: ${({ theme }) => theme.fontSize.xl};
  line-height: 24px;
  font-weight: 200;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: capitalize;

  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 120px;
    font-size: ${({ theme }) => theme.fontSize.x2};
    margin: 1rem 0px;
    border: none;
    background-color: transparent;
  }
`

// Target btn

const MobileBtn = styled(CustomButton)`
  width: 140px;
  height: 45px;
  background-color: transparent;
  color: ${({ theme }) => theme.colors.primary};
  box-sizing: border-box;
  border-radius: 10px;
  padding-bottom: 7px;
  font-size: ${({ theme }) => theme.fontSize.x2};
  line-height: 17px;
`

const EarnBtn = styled(CustomButton)`
  width: -webkit-fill-available;
  height: 38px;
  font-style: normal;
  font-weight: 400;
  font-size: 17.5061px;
  line-height: 21px;
  color: #212761;
  background: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 0px 1.34663px rgba(40, 41, 61, 0.08),
    0px 0.673313px 2.69325px rgba(96, 97, 112, 0.16);
  border-radius: 5.3865px;
`

const CopyBtn = styled(CustomButton)`
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.white};
  width: 420px;
  height: 38px;
  margin-top: 10px;
  text-transform: capitalize;
  font-weight: 100;
  font-size: ${({ theme }) => theme.fontSize.x2};
  line-height: 0;
  border-radius: 10px;
`

const ShareInviteBtn = styled(GeneralWithdraw)`
  height: 35px;
  width: 290px;
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.white};
  border-radius: 6px;
  margin-top: 12px;
  font-size: ${({ theme }) => theme.fontSize.x2};
  font-weight: 500;
`

const PlanPrimaryBtn = styled(GeneralWithdraw)`
  height: 40px;
  width: 120px;
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.white};
  border-radius: 6px;
  margin-top: 12px;
  font-size: ${({ theme }) => theme.fontSize.x2};
  font-weight: 500;
`

const PlanTopUpBtnSm = styled(PlanPrimaryBtn)`
  height: 40px;
  width: 220px;
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.white};
  border-radius: 6px;
  margin-top: 12px;
  font-size: ${({ theme }) => theme.fontSize.x2};
  font-weight: 500;

  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 160px;
    /* font-size: ${({ theme }) => theme.fontSize.x2}; */
    /* margin: 2rem 10px; */
  }
`

const PlanTopUpBtnLg = styled(PlanTopUpBtnSm)`
  width: 190px;
`

const PlanDeleteBtn = styled(PlanTopUpBtnSm)`
  background-color: ${({ theme }) => theme.colors.red};
  color: ${({ theme }) => theme.colors.white};
  border: 1px solid white;
  margin-left: -3px;
`

const PlanTransparentBtn = styled(GeneralWithdraw)`
  height: 40px;
  width: 220px;
  background-color: transparent;
  color: ${({ theme }) => theme.colors.dark};
  border-radius: 6px;
  margin-top: 12px;
  font-weight: 500;

  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 160px;
  }
`

const InvestmentBtn = styled(ModalButton)`
  /* @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 220px;
  } */
`

export {
  CustomButton,
  QuickSaveButton,
  ResetButton,
  InvestButton,
  ModalButton,
  DownloadButton,
  TargetButton,
  RegisterBtn,
  SavingsBtn,
  GeneralSave,
  GeneralWithdraw,
  MobileBtn,
  CollaboDeclineButton,
  CollaboAcceptButton,
  InvestmentLearnButton,
  InvestmentInvestButton,
  InvestModalButton,
  CreateTarget,
  TargetMore,
  TargetFilterBtn,
  CreateEmergency,
  EarnBtn,
  CopyBtn,
  ShareInviteBtn,
  CreateButton,
  PlanPrimaryBtn,
  PlanTransparentBtn,
  PlanTopUpBtnSm,
  PlanTopUpBtnLg,
  PlanDeleteBtn,
  InvestmentBtn,
  HomeQuickSaveBtn,
  EmergencyBtn,
  EmergencyWithdrawBtn,
  InvestSuccessBtn,
  VerificationButton,
  DeleteContestBtn,
}
